import { Pipe, PipeTransform } from '@angular/core';
import {
  AssignmentStatusEnum,
  ProfileAssignmentService,
} from '@app/profile/components/profile-assignments/profile-assignments.service';

@Pipe({
  name: 'AssignmentStatus',
})
export class AssignmentStatusPipe implements PipeTransform {
  constructor(private assignmentsService: ProfileAssignmentService) {}

  public transform(assignmentInfo, assignmentType = 'user'): string {
    const dateDue = assignmentInfo.dateDue;
    const assignmentStatus =
      this.assignmentsService.getAssignmentStatus(dateDue);

    if (!dateDue) {
      return 'DueLater';
    }

    const isComplete =
      assignmentType === 'admin'
        ? assignmentInfo.usersPending === 0
        : assignmentInfo.alreadyCompleted;
    if (isComplete) {
      return 'Complete';
    }

    const isOverDue =
      !isComplete && assignmentStatus === AssignmentStatusEnum.OverDue;
    if (isOverDue) {
      return 'OverDue';
    }

    const isDueLater =
      !isComplete && assignmentStatus === AssignmentStatusEnum.DueLater;
    if (isDueLater) {
      return 'DueLater';
    }

    const isDueSoon = !isComplete && !isDueLater && !isOverDue;
    if (isDueSoon) {
      return 'DueSoon';
    }
  }
}
